/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Faq } from 'ui/atoms/Faq/Faq';
import { OurCustomersV2 } from 'ui/molecules/OurCustomers/OurCustomersV2';
import { DeliveryTable } from 'ui/organisms/DeliveryTable/DeliveryTable';

import styles from './CorporateLinkagePage.module.scss';

import { getDeliveryRows, getFaqData } from './CorporateLinkagePage.data';
import { LinkageHeroSection } from './LinkageHeroSection/LinkageHeroSection';
import { LinkageTableSection } from './LinkageTableSection/LinkageTableSection';
import { SchemaSection } from './SchemaSection/SchemaSection';
import { IncludedSection } from './IncludedSection/IncludedSection';
import { ScreeningSection } from './ScreeningSection/ScreeningSection';
import { BuyersSection } from './BuyersSection/BuyersSection';
import { FinalCtaSection } from './FinalCtaSection/FinalCtaSection';

export const CorporateLinkagePage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <LinkageHeroSection />

      <OurCustomersV2 hasBackground={false} />

      <LinkageTableSection />

      <SchemaSection />

      <IncludedSection />

      <ScreeningSection />

      <BuyersSection />

      <DeliveryTable
        title={t('Take it however your stack needs it')}
        background="#f6f7f9"
        numbered
        rows={getDeliveryRows(t)}
      />

      <FinalCtaSection />

      <Faq className={styles.faq} title={t('Corporate linkage, explained')} data={getFaqData(t)} />
    </div>
  );
};
